// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2ZRS8","buttons":"PendingPaymentAlert_buttons__PvIPs"};